export const isKaraokeSite = () => window.location.origin.includes("karaoke");

export const getAppSource = () => {
  return isKaraokeSite() ? "karaoke" : "muzickematrice";
};
